export default __webpack_public_path__ + "static/media/summary.4e7e7d89.svg";